module.exports = __webpack_public_path__ + "img/Contractor.d3e185ca.svg";